<div class="painel-mia">

  <header class="painel-mia__topo">
    <div>
      <h1 class="painel-mia__titulo">Atendimento no WhatsApp</h1>
      <p class="painel-mia__subtitulo">
        Como a Mia e a sua equipe atendem e vendem, conversa por conversa.
      </p>
    </div>

    <div class="painel-mia__acoes">
      <button *ngIf="ehAdmin"
              type="button"
              class="painel-mia__exportar"
              title="Vereditos do LLM-juiz sobre a atuação da Mia (só admins)"
              (click)="abraQualidade()">
        <i class="fas fa-gavel"></i> Qualidade da Mia
        <span class="painel-mia__selo-admin" title="Visível apenas para administradores do MeuCardápio"><i class="fas fa-lock"></i> Admin</span>
      </button>
      <button *ngIf="ehAdmin"
              type="button"
              class="painel-mia__exportar"
              (click)="exporteConversas()">
        Exportar conversas
        <span class="painel-mia__selo-admin" title="Visível apenas para administradores do MeuCardápio"><i class="fas fa-lock"></i> Admin</span>
      </button>

      <div class="painel-mia__periodos">
        <button *ngFor="let periodo of periodos"
                type="button"
                class="painel-mia__periodo"
                [class.painel-mia__periodo--ativo]="!personalizado && periodo.dias === diasSelecionados"
                (click)="selecionePeriodo(periodo.dias)">
          {{ periodo.rotulo }}
        </button>
        <button type="button"
                class="painel-mia__periodo"
                [class.painel-mia__periodo--ativo]="personalizado"
                (click)="ativePeriodoPersonalizado()">
          Período
        </button>
      </div>
    </div>
  </header>

  <div class="painel-mia__datas" *ngIf="personalizado">
    <div class="painel-mia__data">
      <span class="painel-mia__data-rotulo">De</span>
      <kendo-datetimepicker [(ngModel)]="dataDe"
                            [format]="'dd/MM/yyyy HH:mm'">
        <kendo-datetimepicker-messages today="Hoje"
                                       toggle="Alterar data e horário"
                                       cancel="Cancelar"
                                       dateTab="Data"
                                       timeTab="Hora"
                                       now="Agora"
                                       accept="Ok">
        </kendo-datetimepicker-messages>
      </kendo-datetimepicker>
    </div>

    <div class="painel-mia__data">
      <span class="painel-mia__data-rotulo">Até</span>
      <kendo-datetimepicker [(ngModel)]="dataAte"
                            [format]="'dd/MM/yyyy HH:mm'">
        <kendo-datetimepicker-messages today="Hoje"
                                       toggle="Alterar data e horário"
                                       cancel="Cancelar"
                                       dateTab="Data"
                                       timeTab="Hora"
                                       now="Agora"
                                       accept="Ok">
        </kendo-datetimepicker-messages>
      </kendo-datetimepicker>
    </div>

    <button type="button"
            class="painel-mia__aplicar"
            [disabled]="!periodoValido"
            (click)="apliquePeriodo()">
      Aplicar
    </button>

    <span class="painel-mia__datas-dica"
          [class.painel-mia__datas-dica--erro]="!periodoValido">
      {{ periodoValido
          ? 'O horário também conta: dá para comparar o movimento do almoço com o da noite.'
          : 'Escolha uma data e horário inicial anterior ao final.' }}
    </span>
  </div>

  <div class="painel-mia__carregando" *ngIf="carregando">
    Carregando os números...
  </div>

  <div class="painel-mia__aviso painel-mia__aviso--erro" *ngIf="!carregando && erro">
    {{ erro }}
    <button type="button" class="painel-mia__link" (click)="carregue()">Tentar de novo</button>
  </div>

  <div class="painel-mia__vazio" *ngIf="!carregando && !erro && !temDados">
    <strong>Nenhum atendimento neste período.</strong>
    <span>Os números aparecem aqui assim que as primeiras conversas começarem.</span>
  </div>

  <ng-container *ngIf="!carregando && !erro && temDados">

    <!-- Alarme técnico: problema NOSSO de operar a Mia — só admin do
         MeuCardápio vê. Para o dono seria susto sem ação possível; as
         conversas seguem fora do denominador de conversão do mesmo jeito. -->
    <div class="painel-mia__alarme" *ngIf="ehAdmin && falhasTecnicas > 0">
      <span class="painel-mia__alarme-icone">!</span>
      <div>
        <strong>{{ falhasTecnicas }} {{ falhasTecnicas === 1 ? 'conversa ficou' : 'conversas ficaram' }} sem resposta da Mia.
          <span class="painel-mia__selo-admin" title="Visível apenas para administradores do MeuCardápio"><i class="fas fa-lock"></i> Admin</span></strong>
        <span>Falha técnica: o cliente escreveu e não recebeu retorno. Isso não entra na conta de conversão.</span>
      </div>
    </div>

    <section class="painel-mia__destaques">

      <article class="cartao cartao--principal">
        <span class="cartao__rotulo">Conversão</span>
        <strong class="cartao__numero">{{ conversao }}%</strong>
        <span class="tendencia"
              *ngIf="tendenciaConversao as tendencia"
              [class.tendencia--melhor]="tendencia.direcao === 'melhor'"
              [class.tendencia--pior]="tendencia.direcao === 'pior'">
          <span class="tendencia__seta">{{ tendencia.seta }}</span>
          {{ tendencia.texto }}
        </span>
        <p class="cartao__frase">
          De <strong>{{ elegiveis }}</strong> {{ elegiveis === 1 ? 'pessoa que queria comprar' : 'pessoas que queriam comprar' }},
          <strong>{{ vendas }}</strong> {{ vendas === 1 ? 'fechou' : 'fecharam' }} pedido.
        </p>
        <div class="cartao__barra">
          <span class="cartao__barra-preenchida" [style.width.%]="conversao"></span>
        </div>

        <!-- Assinatura da tela: uma barra única em três cores — as fatias
             somam exatamente as vendas do número acima. -->
        <div class="autoria" *ngIf="autoresDeVenda.length">
          <span class="autoria__titulo">Quem fechou essas vendas</span>
          <div class="autoria__barra">
            <span *ngFor="let autor of autoresDeVenda"
                  class="autoria__fatia autoria__fatia--{{ autor.chave }}"
                  [style.width.%]="autor.percentual"></span>
          </div>
          <ul class="autoria__legenda">
            <li class="autoria__item" *ngFor="let autor of autoresDeVenda">
              <span class="autoria__ponto autoria__ponto--{{ autor.chave }}"></span>
              <span class="autoria__rotulo">{{ autor.rotulo }}</span>
              <strong class="autoria__quantidade">{{ autor.quantidade }}</strong>
            </li>
          </ul>
        </div>
      </article>

      <article class="cartao">
        <span class="cartao__rotulo">Vendas</span>
        <strong class="cartao__numero cartao__numero--medio">{{ faturamento | currency:'BRL':'symbol':'1.2-2' }}</strong>
        <span class="tendencia"
              *ngIf="tendenciaFaturamento as tendencia"
              [class.tendencia--melhor]="tendencia.direcao === 'melhor'"
              [class.tendencia--pior]="tendencia.direcao === 'pior'">
          <span class="tendencia__seta">{{ tendencia.seta }}</span>
          {{ tendencia.texto }}
        </span>
        <p class="cartao__frase">
          Ticket médio de <strong>{{ ticketMedio | currency:'BRL':'symbol':'1.2-2' }}</strong>.
        </p>

        <!-- Exigência de honestidade: cancelado nunca fica invisível ao lado do
             faturamento, senão a conversão parece melhor do que foi. -->
        <p class="cartao__nota" [class.cartao__nota--atencao]="pedidosCancelados > 0">
          <ng-container *ngIf="pedidosCancelados > 0; else semCancelamento">
            {{ pedidosCancelados }} {{ pedidosCancelados === 1 ? 'pedido foi cancelado' : 'pedidos foram cancelados' }}
            depois ({{ valorCancelado | currency:'BRL':'symbol':'1.2-2' }}) — já fora do valor acima.
          </ng-container>
          <ng-template #semCancelamento>Nenhum pedido cancelado no período.</ng-template>
        </p>
      </article>

      <article class="cartao">
        <span class="cartao__rotulo">Atendimentos</span>
        <strong class="cartao__numero cartao__numero--medio">{{ atendimentos }}</strong>
        <span class="tendencia"
              *ngIf="tendenciaAtendimentos as tendencia"
              [class.tendencia--melhor]="tendencia.direcao === 'melhor'"
              [class.tendencia--pior]="tendencia.direcao === 'pior'">
          <span class="tendencia__seta">{{ tendencia.seta }}</span>
          {{ tendencia.texto }}
        </span>
        <p class="cartao__frase">
          <strong>{{ elegiveis }}</strong> {{ elegiveis === 1 ? 'queria' : 'queriam' }} comprar.
          O resto foi dúvida, pós-venda, contato sem resposta ou conversa ainda em andamento.
        </p>
        <p class="cartao__nota" *ngIf="emAndamento > 0">
          {{ emAndamento }} {{ emAndamento === 1 ? 'conversa acontecendo' : 'conversas acontecendo' }} agora.
        </p>
      </article>

    </section>

    <section class="painel-mia__velocidade">
      <header class="painel-mia__secao-topo">
        <h2 class="painel-mia__secao-titulo">Velocidade do atendimento</h2>
        <span class="painel-mia__secao-nota">
          Vale para respostas pelo painel, celular e WhatsApp Web.
        </span>
      </header>

      <div class="painel-mia__tempos">
        <article class="cartao">
          <span class="cartao__rotulo">Espera pelo atendente</span>
          <strong class="cartao__numero cartao__numero--medio cartao__numero--tempo">{{ esperaFormatada }}</strong>
          <span class="tendencia"
                *ngIf="tendenciaEspera as tendencia"
                [class.tendencia--melhor]="tendencia.direcao === 'melhor'"
                [class.tendencia--pior]="tendencia.direcao === 'pior'">
            <span class="tendencia__seta">{{ tendencia.seta }}</span>
            {{ tendencia.texto }}
          </span>
          <p class="cartao__frase" *ngIf="esperaPeloAtendenteSeg !== null; else semEspera">
            Tempo típico que o cliente ficou aguardando a primeira resposta humana
            depois de a Mia chamar alguém da equipe, {{ esperasMedidas === 1 ? 'na conversa escalada' : 'nas ' + esperasMedidas + ' conversas escaladas' }} do período.
          </p>
          <ng-template #semEspera>
            <p class="cartao__frase">Nenhuma conversa precisou esperar por atendente no período.</p>
          </ng-template>
        </article>

        <article class="cartao">
          <span class="cartao__rotulo">Resposta durante o atendimento</span>
          <strong class="cartao__numero cartao__numero--medio cartao__numero--tempo">{{ respostaFormatada }}</strong>
          <span class="tendencia"
                *ngIf="tendenciaResposta as tendencia"
                [class.tendencia--melhor]="tendencia.direcao === 'melhor'"
                [class.tendencia--pior]="tendencia.direcao === 'pior'">
            <span class="tendencia__seta">{{ tendencia.seta }}</span>
            {{ tendencia.texto }}
          </span>
          <p class="cartao__frase" *ngIf="respostaDoAtendenteSeg !== null; else semResposta">
            Tempo típico que o cliente espera por cada resposta do atendente
            enquanto a conversa está com a sua equipe.
          </p>
          <ng-template #semResposta>
            <p class="cartao__frase">Sem conversas com atendente humano no período.</p>
          </ng-template>
        </article>
      </div>
    </section>

    <section class="painel-mia__perdas" *ngIf="motivos.length">
      <header class="painel-mia__secao-topo">
        <h2 class="painel-mia__secao-titulo">Onde a venda se perdeu</h2>
        <span class="painel-mia__secao-nota">
          {{ perdas }} {{ perdas === 1 ? 'venda perdida' : 'vendas perdidas' }} no período —
          <button type="button" class="painel-mia__link painel-mia__link--secao"
                  (click)="abraConversasNaoConvertidas()">ver essas conversas</button>
        </span>
      </header>

      <ul class="motivos">
        <li class="motivos__item"
            *ngFor="let motivo of motivos"
            [class.motivos__item--destaque]="motivo.destaque">
          <div class="motivos__cabecalho">
            <span class="motivos__titulo">{{ motivo.titulo }}</span>
            <span class="motivos__quantidade">{{ motivo.quantidade }}</span>
          </div>
          <div class="motivos__barra">
            <span class="motivos__barra-preenchida" [style.width.%]="motivo.percentual"></span>
          </div>
          <p class="motivos__dica">{{ motivo.dica }}</p>
        </li>
      </ul>
    </section>

    <section class="painel-mia__rodape">

      <article class="nota">
        <span class="nota__rotulo">Outras conversas</span>
        <strong class="nota__numero">{{ inconclusivos }}</strong>
        <p class="nota__texto">
          <ng-container *ngIf="contatosSemResposta > 0">
            <strong>{{ contatosSemResposta }}</strong> {{ contatosSemResposta === 1 ? 'mandou' : 'mandaram' }} mensagem e não {{ contatosSemResposta === 1 ? 'voltou' : 'voltaram' }}.
          </ng-container>
          <ng-container *ngIf="conversasSemPedido > 0">
            <strong>{{ conversasSemPedido }}</strong> {{ conversasSemPedido === 1 ? 'conversou' : 'conversaram' }} —
            dúvidas ou compras combinadas direto com a equipe — sem pedido registrado pelo cardápio.
          </ng-container>
          Não entram na conta de conversão.
        </p>
      </article>

      <article class="nota">
        <span class="nota__rotulo">Passaram por atendente</span>
        <strong class="nota__numero">{{ escalados }}</strong>
        <p class="nota__texto" *ngIf="conversaoEscalados !== null; else semEscalacao">
          {{ conversaoEscalados }}% desses fecharam pedido, contra {{ conversao }}% no geral.
          <ng-container *ngIf="vendasEscaladasPeloAtendente > 0">
            {{ escaladosComVenda === 1 ? 'Na venda escalada' : 'Das ' + escaladosComVenda + ' vendas escaladas' }},
            o atendente registrou o pedido em {{ vendasEscaladasPeloAtendente }}.
          </ng-container>
        </p>
        <ng-template #semEscalacao>
          <p class="nota__texto">Nenhuma conversa precisou de atendente humano no período.</p>
        </ng-template>
      </article>

      <!-- Custo operacional é assunto NOSSO: só admin do MeuCardápio vê. -->
      <article class="nota" *ngIf="ehAdmin">
        <span class="nota__rotulo">Custo de IA <span class="painel-mia__selo-admin" title="Visível apenas para administradores do MeuCardápio"><i class="fas fa-lock"></i> Admin</span></span>
        <strong class="nota__numero">{{ custoFormatado }}</strong>
        <p class="nota__texto">
          Tudo que a Mia gastou de IA no período<ng-container *ngIf="custoPorAtendimento"> —
          média de {{ custoPorAtendimento }} por atendimento</ng-container>.
          Convertido de dólar por cotação fixa.
        </p>
      </article>

    </section>

  </ng-container>

</div>
